<template>
    <div class="checkbox">
        <label :for="name">
            <input
                type="checkbox"
                :checked="checked"
                :name="name"
                :value="value"
                :id="name"
                @change="$emit('change', $event.target.checked)"
            />
            <div class="checkbox__fake-box">
                <img src="/images/icons/success.svg" alt="Success checkmark">
            </div>
            <slot></slot>
        </label>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'checked',
        event: 'change'
    },

    props: {
        name: String,
        value: {
            type: String,
            default: "1"
        },
        checked: Boolean,
    }
}
</script>
